import React from "react";
import HeroSection from "../components/HeroSection";
import Info from "../components/Info";
import About from "../components/AboutFAQs";
import Testimonials from "../components/Testimonials";
import HelpSection from "../components/HelpSection";
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <div>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Respected Solution",
            "url": "https://www.respectedsolution.co"
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Respected Solution Home",
            "url": "https://www.respectedsolution.co/"
          })}
        </script>
      </Helmet>
      <HeroSection />
      <Info />
      <Testimonials />
      <About />
      <HelpSection />
    </div>
  );
};

export default Home;
